import { FC } from 'react';

import TableBody from 'modules/_shared/Table/components/TableBody';

import DividendsOperationTableRow from './DividendsOperationTableRow';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';
import { getPartnersFromOldDividend } from '../../utils/getPartnersFromOldDividend';

const DividendsOperationTableBody: FC = () => {
  const { data } = useOperationDetailsPage();

  const partners = data.isOldOperation
    ? getPartnersFromOldDividend(data.operation)
    : data.partners;

  const hasData = partners?.length > 0;

  const rows = partners!.map((partner, index) => (
    <DividendsOperationTableRow
      // eslint-disable-next-line react/no-array-index-key
      key={`dividend-row-${index}`}
      index={index}
      partner={partner}
    />
  ));

  return (
    <TableBody hasData={hasData} content={rows} noDataMessage="NoDataFound" />
  );
};

export default DividendsOperationTableBody;
